import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { reduxForm, InjectedFormProps, change, Field } from 'redux-form';
import { IModalAction } from 'models/modal';
import * as c from 'models/constants';
import { Modal, Button, ErrorSummary } from 'components';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { ImageUpload, PortalInputField, PortalTextareaField } from 'components/FormControls';
import { IImageData } from 'models/common';
import { ISectionImageElement } from 'models/common/sectionimageelement';
import { onCloseModalForm } from 'helpers/common';
import { PortalPageSection, ButtonsSection } from 'components/PortalStructure';

require('components/Tabs/style.css');
require('./../../style.css');

interface IProps extends InjectedFormProps {
	section: IPortalPageSection;
	baseUrl?: string;
	currentFormValues: IPortalPageSection;
	showHeaderCloseButton: boolean;
	index: number;
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;

	handleSubmit: any;
	saveSection?: (form: IPortalPageSection, index?: number) => void;
	change?: (field: any, value: any) => void;
	showModal?: (modalType: string, modalProps: any) => IModalAction;
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
}

interface IState {
	error: boolean;
	message: any;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditSectionType3Form extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			error: false,
			message: null,
		};

		this.onSubmit = this.onSubmit.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.onChange = this.onChange.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
		this.imageUploadedCallback = this.imageUploadedCallback.bind(this);
		this.imageUploadFailed = this.imageUploadFailed.bind(this);
		this.setError = this.setError.bind(this);
		this.clearError = this.clearError.bind(this);
	}

	private setError(error: any) {
		this.setState({
			error: true,
			message: error,
		});
	}

	private clearError() {
		this.setState({
			error: false,
			message: null,
		});
	}

	private deleteImage(_, additionalData: string[]) {
		this.props.change(additionalData[0], null);
		this.forceUpdate();
	}

	private imageUploadedCallback(id: string, href: string, additionalData: string[]) {
		this.clearError();

		const image: IImageData = {
			id,
			href,
		};

		if (additionalData.length > 0) {
			this.props.change(additionalData[0], image.href);
		}

		this.forceUpdate();
	}

	private imageUploadFailed(error: any) {
		if (error) {
			this.setError(error);
			this.forceUpdate();
		}
	}

	private onSubmit(form: IPortalPageSection) {
		form.seoImageUrl =
			(form.items[0].elements[0] as any).imageUrl ||
			(form.items[0].elements[3] as any).imageUrl ||
			(form.items[0].elements[6] as any).imageUrl ||
			(form.items[0].elements[9] as any).imageUrl ||
			(form.items[0].elements[10] as any).imageUrl;
		this.props.saveSection(form, this.props.index);
	}

	private onChange(field: string, value: any) {
		this.props.change(field, value);
		this.forceUpdate();
	}

	private closeModal() {
		onCloseModalForm(this.props.dirty, this.props.showModal, this.props.closeModal, this.props.t);
	}

	public render() {
		const { handleSubmit, t, showHeaderCloseButton, currentFormValues } = this.props;
		const { error, message } = this.state;

		const errorSummaryProps = {
			error,
			message,
		};

		return (
			<Modal
				title={t('PortalPage_Section_Manage_Common_EditSection')}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={this.closeModal}
				modalClass="portalPageSectionManageWrapper"
			>
				<form onSubmit={handleSubmit(this.onSubmit)}>
					<div>
						<ErrorSummary {...errorSummaryProps} />
					</div>
					<PortalPageSection usage="admin">
						<div className="row">
							<div className="col-md-12">
								<Field
									name="imageUpload"
									component={ImageUpload}
									imageUploadedCallback={this.imageUploadedCallback}
									imageUploadFailed={this.imageUploadFailed}
									additionalData={['items[0].elements[10].imageUrl']}
									existingImageId={
										currentFormValues &&
										currentFormValues.items[0].elements[10] &&
										(currentFormValues.items[0].elements[10] as ISectionImageElement).imageUrl
											? (currentFormValues.items[0].elements[10] as ISectionImageElement).imageUrl
											: null
									}
									existingImageUrl={
										currentFormValues &&
										currentFormValues.items[0].elements[10] &&
										(currentFormValues.items[0].elements[10] as ISectionImageElement).imageUrl
											? (currentFormValues.items[0].elements[10] as ISectionImageElement).imageUrl
											: null
									}
									onDelete={this.deleteImage}
									label="Image"
								/>
							</div>
						</div>

						<div className="row">
							<div className="col-md-12">
								<Field
									name={`items[0].elements[11].text`}
									component={PortalInputField}
									usage="admin"
									type="text"
									label={t('PortalPage_Section_Type3_Label_Title')}
								/>
								<Field name={`items[0].elements[15].text`} component="input" type="hidden" />
							</div>
						</div>
					</PortalPageSection>
					<Tabs name="boxes" tabComponent="div">
						<div className="tabsHolder">
							<TabLink className="tab" to="link1">
								{t('Magazine_Section_Manage_Common_Label_Box') + ' '}1
							</TabLink>
							<TabLink className="tab" to="link2">
								{t('Magazine_Section_Manage_Common_Label_Box') + ' '}2
							</TabLink>
							<TabLink className="tab" to="link3">
								{t('Magazine_Section_Manage_Common_Label_Box') + ' '}3
							</TabLink>
						</div>
						<div className="tabsContent">
							<TabContent for="link1">
								<PortalPageSection usage="admin">
									<div className="row">
										<div className="col-md-12">
											<Field
												name="items[0].elements[1].text"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Title')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="items[0].elements[2].text"
												component={PortalTextareaField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Description')}
											/>
										</div>
									</div>
								</PortalPageSection>
							</TabContent>
							<TabContent for="link2">
								<PortalPageSection usage="admin">
									<div className="row">
										<div className="col-md-12">
											<Field
												name="items[0].elements[4].text"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Title')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="items[0].elements[5].text"
												component={PortalTextareaField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Description')}
											/>
										</div>
									</div>
								</PortalPageSection>
							</TabContent>
							<TabContent for="link3">
								<PortalPageSection usage="admin">
									<div className="row">
										<div className="col-md-12">
											<Field
												name="items[0].elements[7].text"
												component={PortalInputField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Title')}
											/>
										</div>
									</div>

									<div className="row">
										<div className="col-md-12">
											<Field
												name="items[0].elements[8].text"
												component={PortalTextareaField}
												usage="admin"
												type="text"
												label={t('Magazine_Section_Manage_Common_Description')}
											/>
										</div>
									</div>
								</PortalPageSection>
							</TabContent>
						</div>
					</Tabs>
					<ButtonsSection>
						<div className="row">
							<div className="col-sm-12">
								<Button type="submit" usage="admin">
									{t('BSPortal_Common_SaveAndClose')}
								</Button>
							</div>
						</div>
					</ButtonsSection>
				</form>
			</Modal>
		);
	}
}

function mapStateToProps(state, ownProps: IProps) {
	const newProps = {
		type: c.PORTAL_PAGE_SECTION_TYPE_3,
		items: [
			{
				elements: [
					{
						imageUrl: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					{
						imageUrl: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					{
						imageUrl: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					//10
					{
						imageUrl: null,
						redirectUrl: null,
					},
					{
						imageUrl: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
					{
						text: null,
						redirectUrl: null,
					},
				],
			},
		],
	};

	let currentFormValues: IPortalPageSection = null;
	if (state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION3] && state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION3].values) {
		currentFormValues = state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION3].values;
	}

	return {
		initialValues: ownProps.section || newProps,
		currentFormValues,
	};
}

let ManageType3 = reduxForm(
	{
		form: c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION3,
		enableReinitialize: true,
	},
	mapStateToProps,
)(EditSectionType3Form);

ManageType3 = connect(mapStateToProps, (dispatch) => ({
	change: (field: string, value: string) => dispatch(change(field, value)),
}))(ManageType3);

export { ManageType3 };
